export default __webpack_public_path__ + "static/media/outside1.16936605.jpg";